<div>
  <mat-progress-bar *ngIf="isProgressBar" mode="query"></mat-progress-bar>
  <mat-progress-spinner [diameter]="54" *ngIf="isSpinner" mode="indeterminate"></mat-progress-spinner>
  <div *ngIf="data.title" class="mat-title mb-0 mt-4 text-center">{{ data.title }}</div>
</div>
